import {
  FEEDBACK_PROMPT_FIRST_TEST_KEY,
  FEEDBACK_PROMPT_SNOOZE_UNTIL_KEY,
  FEEDBACK_PROMPT_STATUS_KEY,
  FeedbackPromptStatus,
} from 'constants/feedback-prompt'
import store from 'store2'

const parseTimestamp = (value: unknown): number | null => {
  if (value === undefined || value === null) return null

  const parsed = typeof value === 'number' ? value : parseInt(String(value), 10)

  return Number.isFinite(parsed) ? parsed : null
}

export const getFirstTestCompletedAt = (): number | null => {
  return parseTimestamp(store(FEEDBACK_PROMPT_FIRST_TEST_KEY))
}

export const setFirstTestCompletedAtIfAbsent = ({ timestamp }: { timestamp: number }): void => {
  if (getFirstTestCompletedAt() !== null) return

  store(FEEDBACK_PROMPT_FIRST_TEST_KEY, timestamp)
}

export const getFeedbackPromptStatus = (): FeedbackPromptStatus | null => {
  const status = store(FEEDBACK_PROMPT_STATUS_KEY)

  if (
    status === FeedbackPromptStatus.SUBMITTED ||
    status === FeedbackPromptStatus.DISMISSED_FOREVER ||
    status === FeedbackPromptStatus.SNOOZED
  ) {
    return status
  }

  return null
}

export const setFeedbackPromptStatus = ({ status }: { status: FeedbackPromptStatus }): void => {
  store(FEEDBACK_PROMPT_STATUS_KEY, status)
}

export const getFeedbackPromptSnoozeUntil = (): number | null => {
  return parseTimestamp(store(FEEDBACK_PROMPT_SNOOZE_UNTIL_KEY))
}

export const setFeedbackPromptSnoozeUntil = ({ timestamp }: { timestamp: number }): void => {
  store(FEEDBACK_PROMPT_SNOOZE_UNTIL_KEY, timestamp)
}

export const clearFeedbackPromptSnoozeUntil = (): void => {
  store.remove(FEEDBACK_PROMPT_SNOOZE_UNTIL_KEY)
}
